import type { Filters } from './filters';

const _priceHigh = [
  { label: '$100K', value: '100000' },
  { label: '$200K', value: '200000' },
  { label: '$300K', value: '300000' },
  { label: '$400K', value: '400000' },
  { label: '$500K', value: '500000' },
  { label: '$600K', value: '600000' },
  { label: '$700K', value: '700000' },
  { label: '$800K', value: '800000' },
  { label: '$900K', value: '900000' },
  { label: '$1M', value: '1000000' },
  { label: 'No max', value: '' },
];

export function PriceHighOptions(
  this: Filters,
): { disabled: boolean; label: string; value: string }[] {
  return _priceHigh.map((o) => ({
    ...o,
    disabled:
      o.value !== '' &&
      this.filteringService.priceLow() !== '' &&
      parseInt(o.value) <= parseInt(this.filteringService.priceLow()),
  }));
}
